import React, { Component } from "react";
import { Select, MenuItem, FormHelperText, InputLabel, FormControl } from '@material-ui/core';

class SelectField extends Component {
	constructor(props) {
		super(props)
		this.state = {
			className: this.props.className,
			classNameJS: this.props.classNameJS,
			isRequired: this.props.isRequired,
			options: this.props.options,
			selectName: this.props.selectName,
			defaultValue: this.props.defaultValue,
			errorMsg: this.props.errorMsg,
			buttonID: this.props.buttonID,
			onChange: this.props.onChange,
			valueType: this.props.valueType,
			saveResponse: this.props.saveResponse,
			state: ''
		}
		this.handleChange = this.handleChange.bind(this)
	}

	handleChange(event) {
		this.setState({
			state: event.target.value
		});
		this.state.onChange({
			name: event.target.name,
			value: event.target.value,
			type: 'select'
		});
	}

	render() {
		const createClassList = () => {
			let classList = 'ca-select-field';
			if (this.state.className) classList = classList + ' ca-select-field--' + this.state.className;
			if (this.state.classNameJS) classList = classList + ' ' + this.state.classNameJS;
			if (this.state.isRequired) classList = classList + ' js-required';
			return classList;
		};
	
		const getStates = () => {
			const states = [
				{
					"name": "State",
					"value": "",
					"disabled": true,
					"selected": true
				},
				{
					"name": "Alabama",
					"value": "AL"
				},
				{
					"name": "Alaska",
					"value": "AK"
				},
				{
					"name": "Arizona",
					"value": "AZ"
				},
				{
					"name": "Arkansas",
					"value": "AR"
				},
				{
					"name": "California",
					"value": "CA"
				},
				{
					"name": "Colorado",
					"value": "CO"
				},
				{
					"name": "Connecticut",
					"value": "CT"
				},
				{
					"name": "Delaware",
					"value": "DE"
				},
				{
					"name": "District Of Columbia",
					"value": "DC"
				},
				{
					"name": "Florida",
					"value": "FL"
				},
				{
					"name": "Georgia",
					"value": "GA"
				},
				{
					"name": "Hawaii",
					"value": "HI"
				},
				{
					"name": "Idaho",
					"value": "ID"
				},
				{
					"name": "Illinois",
					"value": "IL"
				},
				{
					"name": "Indiana",
					"value": "IN"
				},
				{
					"name": "Iowa",
					"value": "IA"
				},
				{
					"name": "Kansas",
					"value": "KS"
				},
				{
					"name": "Kentucky",
					"value": "KY"
				},
				{
					"name": "Louisiana",
					"value": "LA"
				},
				{
					"name": "Maine",
					"value": "ME"
				},
				{
					"name": "Maryland",
					"value": "MD"
				},
				{
					"name": "Massachusetts",
					"value": "MA"
				},
				{
					"name": "Michigan",
					"value": "MI"
				},
				{
					"name": "Minnesota",
					"value": "MN"
				},
				{
					"name": "Mississippi",
					"value": "MS"
				},
				{
					"name": "Missouri",
					"value": "MO"
				},
				{
					"name": "Montana",
					"value": "MT"
				},
				{
					"name": "Nebraska",
					"value": "NE"
				},
				{
					"name": "Nevada",
					"value": "NV"
				},
				{
					"name": "New Hampshire",
					"value": "NH"
				},
				{
					"name": "New Jersey",
					"value": "NJ"
				},
				{
					"name": "New Mexico",
					"value": "NM"
				},
				{
					"name": "New York",
					"value": "NY"
				},
				{
					"name": "North Carolina",
					"value": "NC"
				},
				{
					"name": "North Dakota",
					"value": "ND"
				},
				{
					"name": "Ohio",
					"value": "OH"
				},
				{
					"name": "Oklahoma",
					"value": "OK"
				},
				{
					"name": "Oregon",
					"value": "OR"
				},
				{
					"name": "Pennsylvania",
					"value": "PA"
				},
				{
					"name": "Rhode Island",
					"value": "RI"
				},
				{
					"name": "South Carolina",
					"value": "SC"
				},
				{
					"name": "South Dakota",
					"value": "SD"
				},
				{
					"name": "Tennessee",
					"value": "TN"
				},
				{
					"name": "Texas",
					"value": "TX"
				},
				{
					"name": "Utah",
					"value": "UT"
				},
				{
					"name": "Vermont",
					"value": "VT"
				},
				{
					"name": "Virginia",
					"value": "VA"
				},
				{
					"name": "Washington",
					"value": "WA"
				},
				{
					"name": "West Virginia",
					"value": "WV"
				},
				{
					"name": "Wisconsin",
					"value": "WI"
				},
				{
					"name": "Wyoming",
					"value": "WY"
				}
			]
			let optionFields = states.map((option, index) => (
				<MenuItem value={option.value} key={index}>{option.name}</MenuItem>
			));
			return optionFields;
		}

		return (
			<div className={createClassList()} data-button-id={this.state.buttonID}>
	
				<FormControl>
					<InputLabel id="select-state-label">State *</InputLabel>
					<Select
						variant="outlined"
						labelId="select-state-label"
						id="select-state"
						value={this.state.state}
						label="State *"
						name="state"
						required={true}
						onChange={this.handleChange}
						data-save={this.state.saveResponse}
					>
						{getStates()}
					</Select>
					<FormHelperText>Please enter a valid state</FormHelperText>
				</FormControl>
			</div>
		);
	}
}

export default SelectField;

{
	/* <SelectField
    classNameJS="js-show--button"
    isRequired={item.form.required}
    options={item.options}
    buttonID={item.form.buttonID}
    selectName={item.form.name}
    defaultValue={item.defaultValue}
    onChange={this.handleChange}
/> */
}
